<template>
  <div class="text-center ma-2">
    <v-snackbar
      v-model="snackbar"
      class=""
    >
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  computed: {
    snackbar: {
      get(){
        return this.$store.getters.getSnackBar
      },
      set(value){
        this.$store.commit('setSnackBar', value)
      }
    },
    text: {
      get(){
        return this.$t(this.$store.getters.getSnackText, this.$store.getters.getSnackParameter)
      }
    },
    
  }
}
</script>